import React, { useState, useEffect } from 'react';
import { AddItemMainReusable } from '../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/AddItem/AddItem';
//import AddItemMainReusable from "../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/AddItem/AddItem";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  get_item_details_from_item_id,
  update_item_menu_setup,
} from '../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction';
import { AmealioLoader } from '../../Loader/AmealioLoader';
const AddItemMain = (props) => {
  const [step, setStep] = useState(1);

  const [loader, setLoader] = useState(true);

  const navigateToStep = (stepNo) => {
    setStep(stepNo);
  };

  useEffect(() => {
    if (props && props.activeItemId && props.activeItemId.length > 2) {
      const token = props.auth.user.accessToken;
      props.get_item_details_from_item_id(props.activeItemId, token);
    }
    setLoader(false);
  }, [props.activeItemId]);

  useEffect(() => {
    if (Object.entries(props.menuCategoryItems).length !== 0) {
      setStep(props.menuCategoryItems.runingTrack);
    }
  }, [props.menuCategoryItems && props.menuCategoryItems.runingTrack]);
  return (
    <React.Fragment>
      {loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div
            // id="onboarding-scrollbar"
            style={{ overflow: 'unset' }}
            className={`p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-8  new-subscription-onboarding-component ${
              !props.dash && `onboarding_process_screen_left`
            }`}
          >
            {/* <TopProgressionIndicator phase={phase} setPhase={setPhase} />
      <hr />
      {phase === 0 && <Step1 />} */}
            <AddItemMainReusable
              step={step}
              setStep={setStep}
              dash={true}
              menuCategoryItems={props.menuCategoryItems}
              navigateToStep={(stepNo) => navigateToStep(stepNo)}
              itemPathName={props.pathname}
              menuData={props.menuData}
              // style={{ fontSize: "0.72917vw" }}
            />
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

// const TopProgressionIndicator = (props) => {
//   return (
//     <div
//       style={{}}
//       className="d-flex row justify-content-between top-progression-indicator-phase-add-itemavail"
//     >
//       {phases.map((data, index) => {
//         return (
//           <div
//             className="col-md-1 "
//             style={{ fontWeight: data.id <= props.phase && "bold" }}
//             onClick={() => {
//               props.setPhase(data.id);
//             }}
//           >
//             <div className="d-flex">
//               <div
//                 className={`inner-div ${
//                   data.id <= props.phase && `inner-div-selected`
//                 }`}
//               >{`0${index + 1}`}</div>
//               <hr />
//             </div>
//             Step {index + 1} :<br />
//             {data.title}
//           </div>
//         );
//       })}
//     </div>
//   );
// };

AddItemMain.propTypes = {
  auth: PropTypes.object.isRequired,
  get_item_details_from_item_id: PropTypes.func.isRequired,
  update_item_menu_setup: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors && state.errors.errors,
  menuCategoryItems: state.onboarding && state.onboarding.menuCategoryItems,
  activeItemId: state.onboarding && state.onboarding.activeItemId,
});

export default connect(mapStateToProps, {
  get_item_details_from_item_id,
  update_item_menu_setup,
})(AddItemMain);
